<template>
  <div>
    <v-text-field
      outlined
      label="IDISA *"
      v-model="park.idisa"
      dense
      :disabled="readOnly"
      required
    />
    <v-text-field
      outlined
      label="Prénom *"
      v-model="park.firstname"
      dense
      :disabled="readOnly"
      required
    />
    <v-text-field
      outlined
      label="Nom *"
      v-model="park.lastname"
      dense
      :disabled="readOnly"
      required
    />
    <v-text-field
      outlined
      label="E-mail *"
      v-model="park.email"
      dense
      :disabled="readOnly"
      required
    />
    <v-select
      outlined
      label="Lieu de travail / d'étude principal *"
      dense
      :items="sites"
      v-model="park.site"
      :disabled="readOnly"
    ></v-select>
    <v-select
      outlined
      label="Type *"
      v-model="park.type"
      :items="types"
      dense
      :disabled="readOnly"
      required
    ></v-select>
    <v-select
      outlined
      label="Type d'études *"
      v-model="park.studyType"
      dense
      :disabled="readOnly"
      required
      :items="studyTypes"
      v-if="park.type === 'Étudiant'"
    ></v-select>
    <v-radio-group
      v-model="park.unityType"
      row
      v-if="['Collaborateur', 'Apprenti'].indexOf(park.type) > -1"
      :disabled="readOnly"
    >
      <v-radio
        label="Département"
        color="primary"
        value="departments"
      ></v-radio>
      <v-radio label="Centre" color="primary" value="centers"></v-radio>
      <v-radio label="Service" color="primary" value="services"></v-radio>
      <v-radio
        label="Support transversal"
        color="primary"
        value="transversals"
      ></v-radio>
      <v-radio
        label="Direction et état-major de la Direction"
        color="primary"
        value="direction"
      ></v-radio>
      <v-radio label="Autre" color="primary" value="others"></v-radio>
    </v-radio-group>
    <v-select
      dense
      outlined
      :label="unities.labels[park.unityType]"
      v-model="park.unity"
      :items="unities[park.unityType]"
      :disabled="readOnly"
    ></v-select>
    <v-autocomplete
      outlined
      dense
      label="Adresse"
      v-model="park.address"
      :items="addresses"
      :search-input.sync="searchAddresses"
      :loading="loadingAddresses"
      :filter="customFilter"
      :disabled="readOnly"
      v-if="addressType === 'local'"
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>Recherchez une adresse...</v-list-item-title>
        </v-list-item>
      </template>
      <template v-slot:selection="{ item }">
        <div v-html="item.text"></div>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title v-html="item.text"></v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
    <v-textarea
      outlined
      dense
      v-model="park.address.label"
      v-else
      :disabled="readOnly"
      label="Adresse"
      auto-grow
    ></v-textarea>
    <v-text-field
      outlined
      label="Immatriculation du véhicule *"
      v-model="park.registration"
      dense
      :disabled="readOnly"
      required
    />
    <div class="pa-10 rounded" style="border: solid 1px silver">
      <div>
        <v-row>
          <v-col>
            <div class="subtitle-1">Enfants à charge</div>
          </v-col>
        </v-row>
      </div>
      <v-item-group
        active-class="grey lighten-2"
        v-model="park.children"
        class="mb-5"
        mandatory
      >
        <v-row>
          <v-col sm="2" class="pr-0">
            <v-item v-slot:default="{ toggle }" :value="false">
              <v-card
                v-if="!readOnly"
                class="d-flex align-center rounded-l-xl rounded-r-0"
                :rounded="false"
                height="40"
                @click="toggle"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Non</div>
                </v-scroll-y-transition>
              </v-card>
              <v-card
                v-else
                class="d-flex align-center rounded-l-xl rounded-r-0"
                :rounded="false"
                height="40"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Non</div>
                </v-scroll-y-transition>
              </v-card>
            </v-item>
          </v-col>
          <v-col sm="2" class="pl-0">
            <v-item v-slot:default="{ toggle }" :value="true">
              <v-card
                v-if="!readOnly"
                class="d-flex align-center rounded-r-xl rounded-l-0"
                height="40"
                @click="toggle"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Oui</div>
                </v-scroll-y-transition>
              </v-card>
              <v-card
                v-else
                class="d-flex align-center rounded-r-xl rounded-l-0"
                height="40"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Oui</div>
                </v-scroll-y-transition>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
      <v-textarea
        v-if="park.children"
        outlined
        dense
        :disabled="readOnly"
        label="Explications complémentaires"
        v-model="park.childrenReason"
        auto-grow
      ></v-textarea>
      <v-radio-group
        v-if="park.children && readOnly"
        v-model="park.childrenValidated"
        row
      >
        <v-radio label="Validé" :value="true"></v-radio>
        <v-radio label="Refusé" :value="false"></v-radio>
      </v-radio-group>
    </div>

    <div class="pa-10 rounded mt-5" style="border: solid 1px silver">
      <div>
        <v-row>
          <v-col class="subtitle-1"
            >Déplacements professionnels fréquents</v-col
          >
        </v-row>
      </div>
      <v-item-group
        active-class="grey lighten-2"
        v-model="park.corporate"
        class="mb-5"
        mandatory
      >
        <v-row>
          <v-col sm="2" class="pr-0">
            <v-item v-slot:default="{ toggle }" :value="false">
              <v-card
                v-if="!readOnly"
                class="d-flex align-center rounded-l-xl rounded-r-0"
                :rounded="false"
                height="40"
                @click="toggle"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Non</div>
                </v-scroll-y-transition>
              </v-card>
              <v-card
                v-else
                class="d-flex align-center rounded-l-xl rounded-r-0"
                :rounded="false"
                height="40"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Non</div>
                </v-scroll-y-transition>
              </v-card>
            </v-item>
          </v-col>
          <v-col sm="2" class="pl-0">
            <v-item v-slot:default="{ toggle }" :value="true">
              <v-card
                v-if="!readOnly"
                class="d-flex align-center rounded-r-xl rounded-l-0"
                height="40"
                @click="toggle"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Oui</div>
                </v-scroll-y-transition>
              </v-card>
              <v-card
                v-else
                class="d-flex align-center rounded-r-xl rounded-l-0"
                height="40"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Oui</div>
                </v-scroll-y-transition>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
      <v-textarea
        v-if="park.corporate"
        outlined
        dense
        :disabled="readOnly"
        label="Explications complémentaires"
        v-model="park.corporateReason"
        auto-grow
      ></v-textarea>
      <v-radio-group
        v-if="park.corporate && readOnly"
        v-model="park.corporateValidated"
        row
      >
        <v-radio label="Validé" :value="true"></v-radio>
        <v-radio label="Refusé" :value="false"></v-radio>
      </v-radio-group>
    </div>

    <div class="pa-10 rounded mt-5" style="border: solid 1px silver">
      <div>
        <v-row>
          <v-col class="subtitle-1"
            >Déplacements pour des raisons médicales fréquents</v-col
          >
        </v-row>
      </div>
      <v-item-group
        active-class="grey lighten-2"
        v-model="park.health"
        class="mb-5"
        mandatory
      >
        <v-row>
          <v-col sm="2" class="pr-0">
            <v-item v-slot:default="{ toggle }" :value="false">
              <v-card
                v-if="!readOnly"
                class="d-flex align-center rounded-l-xl rounded-r-0"
                :rounded="false"
                height="40"
                @click="toggle"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Non</div>
                </v-scroll-y-transition>
              </v-card>
              <v-card
                v-else
                class="d-flex align-center rounded-l-xl rounded-r-0"
                :rounded="false"
                height="40"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Non</div>
                </v-scroll-y-transition>
              </v-card>
            </v-item>
          </v-col>
          <v-col sm="2" class="pl-0">
            <v-item v-slot:default="{ toggle }" :value="true">
              <v-card
                v-if="!readOnly"
                class="d-flex align-center rounded-r-xl rounded-l-0"
                height="40"
                @click="toggle"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Oui</div>
                </v-scroll-y-transition>
              </v-card>
              <v-card
                v-else
                class="d-flex align-center rounded-r-xl rounded-l-0"
                height="40"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Oui</div>
                </v-scroll-y-transition>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
      <div class="subtitle-1" v-if="park.health && readOnly">
        Attestation du médecin
      </div>
      <a @click="downloadFile(park.healthDocument)">{{
        park.healthDocument
      }}</a>
      <v-radio-group
        v-if="park.health && readOnly"
        v-model="park.healthValidated"
        row
      >
        <v-radio label="Validé" :value="true"></v-radio>
        <v-radio label="Refusé" :value="false"></v-radio>
      </v-radio-group>
    </div>

    <div class="pa-10 rounded mt-5" style="border: solid 1px silver">
      <div>
        <v-row>
          <v-col class="subtitle-1">Covoiturage</v-col>
        </v-row>
      </div>
      <v-item-group
        active-class="grey lighten-2"
        v-model="park.carpool"
        class="mb-5"
        mandatory
      >
        <v-row>
          <v-col sm="2" class="pr-0">
            <v-item v-slot:default="{ toggle }" :value="false">
              <v-card
                v-if="!readOnly"
                class="d-flex align-center rounded-l-xl rounded-r-0"
                :rounded="false"
                height="40"
                @click="toggle"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Non</div>
                </v-scroll-y-transition>
              </v-card>
              <v-card
                v-else
                class="d-flex align-center rounded-l-xl rounded-r-0"
                :rounded="false"
                height="40"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Non</div>
                </v-scroll-y-transition>
              </v-card>
            </v-item>
          </v-col>
          <v-col sm="2" class="pl-0">
            <v-item v-slot:default="{ toggle }" :value="true">
              <v-card
                v-if="!readOnly"
                class="d-flex align-center rounded-r-xl rounded-l-0"
                height="40"
                @click="toggle"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Oui</div>
                </v-scroll-y-transition>
              </v-card>
              <v-card
                v-else
                class="d-flex align-center rounded-r-xl rounded-l-0"
                height="40"
                outlined
              >
                <v-scroll-y-transition>
                  <div class="flex-grow-1 text-center">Oui</div>
                </v-scroll-y-transition>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
      <div class="subtitle-1 mb-2" v-if="park.carpool">Covoitureurs</div>
      <v-data-table
        :headers="[]"
        :items="park.carpoolers"
        hide-default-header
        hide-default-footer
        class="elevation-1"
        v-if="readOnly"
      >
        <template v-slot:body="{ items }">
          <tbody class="text-left">
            <tr v-for="item in items" :key="item._id">
              <td>{{ item.firstname }} {{ item.lastname }}</td>
              <td>{{ item.email }}</td>
              <td
                v-if="item.address"
                v-html="item.address.label.replace('\n', ', ')"
              ></td>
              <td>
                <status-badge :validated="item.validated" />
              </td>
              <td>
                <v-tooltip right justify="end">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      @click="copyValidationLink(item)"
                      ><v-icon small>mdi-content-copy</v-icon></v-btn
                    >
                  </template>
                  <span>Copier le lien de validation</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-autocomplete
        v-model="park.carpoolers"
        :items="carpoolers"
        :search-input.sync="searchCarpoolers"
        label="Personnes qui patageront le trajet *"
        outlined
        multiple
        @input="clearSearchCarpoolers"
        no-data-text="Tapez le nom d'une personne..."
        v-if="park.carpool && !readOnly"
        counter="4"
        :rules="[
          (value) => {
            return this.park.carpoolers.length > 4
              ? 'Le nombre de covoitureur est limité à 4'
              : true;
          },
        ]"
        required
      >
        <template v-slot:selection="data">
          <v-chip
            :color="data.item.value.validated ? 'success' : 'warning'"
            small
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            @click="data.select"
            @click:close="remove(data.item)"
            >{{ data.item.text }}
            <v-btn
              v-if="data.item.value.nano"
              icon
              @click="copyValidationLink(data.item.value)"
              ><v-icon small color="white">mdi-content-copy</v-icon></v-btn
            ></v-chip
          >
        </template>
      </v-autocomplete>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import StatusBadge from "@/components/StatusBadge";
import fileDownload from "js-file-download";
import _ from "lodash";

export default {
  name: "Park",
  props: ["park", "readOnly", "openSnackbar"],
  components: { StatusBadge },
  mounted() {
    this.addresses = [
      { text: this.park.address.label, value: this.park.address },
    ];
    this.addressType =
      Object.keys(this.park.address).length > 1 ? "local" : "aborad";
    this.formattedUnities = Object.keys(this.unities)
      .flatMap((key) => {
        if (key !== "labels") {
          const formatted = this.unities[key].map((u) => ({
            value: u,
            type: key,
          }));
          return formatted;
        }
      })
      .filter((x) => x);
    if (this.park.carpoolers && !this.readOnly) {
      this.carpoolers = this.park.carpoolers.map((c) => ({
        text: `${c.firstname} ${c.lastname}`,
        value: {
          firstname: c.firstname,
          lastname: c.lastname,
          email: c.email,
          address: "",
          validated: c.validated,
          nano: c.nano,
        },
      }));
      this.park.carpoolers = this.park.carpoolers.map((c) => ({
        firstname: c.firstname,
        lastname: c.lastname,
        email: c.email,
        address: "",
        validated: c.validated,
        nano: c.nano,
      }));
    }
  },
  data: () => ({
    sites: ["Cheseaux", "St-Roch", "Y-Parc"],
    formattedUnities: [],
    addressType: "",
    searchAddresses: null,
    types: ["Apprenti", "Assistant étudiant", "Collaborateur", "Étudiant"],
    studyTypes: ["Plein temps", "En emploi / Temps partiel"],
    unities: {
      labels: {
        departments: "Département *",
        centers: "Centre *",
        services: "Service *",
        transversals: "Support transversal *",
        direction: "Direction et état-major de Direction *",
        others: "Autre *",
      },
      departments: ["COMEM+", "EC+G", "HEG", "TIC", "TIN"],
      centers: [
        "Formation continue",
        "Formation de base",
        "Ra&D, innovation et transfert de technologie",
        "Relations Internationales",
      ],
      services: [
        "Communication & vie du campus",
        "Finances",
        "Infrastructures & bâtiments",
        "Ressources humaines",
        "Informatique & systèmes d'information",
      ],
      transversals: ["Innovation", "SIPA", "Secrétariat académique"],
      direction: ["Direction", "Etat-major de la Direction"],
      others: ["Concierge", "Restaurant"],
    },
    addresses: [],
    searchCarpoolers: null,
    carpoolers: [],
    loading: false,
    loadingAddresses: false,
    submitting: false,
    snackbar: {
      visible: false,
      color: "",
      text: "",
    },
    valid: false,
    validation: {
      required: (value) => !!value || "Ce champ est requis.",
    },
  }),
  watch: {
    searchCarpoolers: _.debounce(function (val) {
      val &&
        val !== this.park.carpoolers &&
        this.queryPicker(val, "carpoolers");
    }, 300),
    addressType: function (after, before) {
      if (before) {
        this.park.address = {};
        this.addresses = [];
      }
    },
    searchAddresses: _.debounce(function (val) {
      val && val !== this.park.address && this.queryAddresses(val);
    }, 500),
    "park.address": function () {
      if (!this.park.address) {
        this.park.address = {};
      }
    },
    "park._id": function (_id) {
      if (_id) {
        this.type = this.formattedUnities.find(
          (fo) => fo.value === this.park.unity
        ).type;
        this.addresses = [
          { text: this.park.address.label, value: this.park.address },
        ];
        this.addressType =
          Object.keys(this.park.address).length > 1 ? "local" : "aborad";
      }
    },
    "park.type": function () {
      this.park.studyType = "";
      this.park.unityType = "departments";
    },
    "park.unityType": function () {
      this.park.unity = "";
    },
  },
  methods: {
    remove(item) {
      const index = this.park.carpoolers
        .map((c) => c.nano)
        .indexOf(item.value.nano);
      if (index >= 0) this.park.carpoolers.splice(index, 1);
    },
    async queryPicker(v, key) {
      this.loading = true;
      const { data: contacts } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_PEOPLEPICKER_URI}/search?s=${v}`,
        headers: {
          "x-api-key": process.env.VUE_APP_PEOPLEPICKER_KEY,
        },
      });
      contacts.map((c) => {
        if (c.email !== this.park.email) {
          this[key].push({
            text: `${c.firstname} ${c.lastname}`,
            value: {
              firstname: c.firstname,
              lastname: c.lastname,
              email: c.email,
              address: "",
            },
          });
        }
      });
      this[key] = _.uniqBy(this[key], "value.email");
      this.loading = false;
    },
    clearSearchCarpoolers() {
      this.searchCarpoolers = null;
    },
    copyValidationLink({ nano }) {
      navigator.clipboard.writeText(
        `https://park-validation.heig-vd.ch/carpool/${nano}`
      );
      this.openSnackbar({
        visible: true,
        text: "Lien de validation copié",
        color: "primary",
      });
    },
    async queryAddresses(v) {
      this.loadingAddresses = true;

      try {
        const { data: mapboxData } = await axios({
          method: "get",
          url: process.env.VUE_APP_MAPBOX_URI,
          params: {
            q: v,
            access_token: process.env.VUE_APP_MAPBOX_TOKEN,
            language: "fr",
            country: "CH,FR,DE,IT",
            types: "address,street",
            proximity: "46.779089,6.659356",
          },
        });

        this.addresses = mapboxData.features.map((r) => ({
          text: r.properties.full_address,
          value: {
            label: r.properties.full_address,
            lat: r.geometry.coordinates[1],
            lon: r.geometry.coordinates[0],
          },
        }));
      } catch (error) {
        console.error("Error fetching addresses:", error);
        this.addresses = [];
      } finally {
        this.loadingAddresses = false;
      }
    },
    customFilter(item, queryText) {
      const normalizedQuery = this.normalizeText(queryText);
      const normalizedAddress = this.normalizeText(item.text);

      // Split query into parts (e.g., "rue du test city" -> ["rue", "du", "test", "city"])
      const queryParts = normalizedQuery.split(" ");

      // Check if all parts of the query exist in the address
      return queryParts.every((part) => normalizedAddress.includes(part));
    },

    normalizeText(text) {
      return text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // Remove diacritics
        .replace(/[^a-z0-9\s]/g, " ") // Replace special chars with spaces
        .replace(/\s+/g, " ") // Replace multiple spaces with single space
        .trim();
    },
    downloadFile: async function (filename) {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/files/${filename}`,
        responseType: "arraybuffer",
      });
      fileDownload(data, filename);
    },
    isValid(item) {
      const validation = item.carpoolers.map((c) => c.validated);
      if (validation.indexOf(null) > -1) {
        return null;
      }
      if (validation.indexOf(false) > -1) {
        return false;
      }
      return true;
    },
  },
};
</script>